/**
 * 页面缩放
 * @param {*} el 缩放的 dom
 * @param {*} width 按比例缩放的宽，默认是 1920
 * @param {*} height 按比例缩放的高，默认是 976
 */
export const scale = (el, width = 1920, height = 976) => {
  const _el = document.getElementById(el) || document.body
  const scaleX = window.innerWidth / width
  const scaleY = window.innerHeight / height
  _el.style.transform = `scale(${scaleX}, ${scaleY})`
}

/**
 * 节流
 * @param {*} fn 回调函数
 * @param {*} t 时间
 */
export const throttle = (fn, t = 200) => {
  let lastTimes = 0
  let timer
  return function () {
    const nowTimes = +new Date()
    if (lastTimes && nowTimes - lastTimes < t) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        lastTimes = nowTimes
        fn.apply(this, ...arguments)
      }, t)
    } else {
      lastTimes = nowTimes
      fn.apply(this, ...arguments)
    }
  }
}

/**
 * 转化 Rows 里的数据
 * @param {*} array 数组
 * @return {*} 一维数组
 */
export const traverRows = (array) => {
  const result = []
  function travers(rst) {
    rst.forEach(v => {
      if (v.schema && v.schema.length) {
        travers(v.schema)
      }
      result.push(v)
    })
  }
  travers(array)
  return result
}


// 布局类组件
// const LayoutComponent = ['Button', 'Title', 'Space']

/**
 * 将组件数据转换为 后端需要的数据  只转换格式
 *  space button
 */
export const transForEnd = (json) => {
  //深拷贝一份
  const formData = JSON.parse(JSON.stringify(json))
  formData.rows = []
  //处理行容器
  formData.schema.forEach((v, i) => {
    // 存在行容器
    if (v.schema) {
      //收集id
      v.ids = v.schema.map(v => v.id)
      // 替换位置
      formData.schema.splice(i, 1, v.schema)
      delete v.schema
      formData.rows.push(v)
    }
  })
  // 展开
  formData.schema = formData.schema.flat()
  return formData
}


/**
 * 将后台数据转换成前端组件所需数据  传入为json
 */
export const transForFront = (defaultValue) => {
  const json = JSON.parse(defaultValue)
  //处理行容器
  const { rows = [], schema } = json
  delete json.rows
  rows.forEach(v => {
    v.schema = []
    const first = schema.findIndex(val => val.id === v.ids[0])
    v.ids.forEach(val => {
      v.schema.push(schema.find(value => value.id === val))
    })
    schema.splice(first, v.ids.length, v)
    delete v.ids
  })
  return json
}
